export const USER_ACCOUNT_TYPES = {
  Employee: 'Employee',
  Prospect: 'Prospect',
  Customer: 'Customer',
} as const;

export const PROJECT_MEMBERS_PAGE_URL_REGEXP = /^\/projects\/\d+$/;

export const EMAIL_UNIQUE_PROJECT = 0;
export const EMAIL_NON_UNIQUE_PROJECT = 1;
